import api from './index';

let exports = {};

// 工单执行情况报表
exports.statisServicerShopWorkVoucherInfo = function (data, callback) {
    api.post('/statis/work/servicer/shop/list/get')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};

// 网点业务统计  -- 导出
exports.doStatisServicerShopWorkVoucherInfoForExport = function (data, callback) {
    api.post('/statis/work/servicerShop/workload/statis/list/export/do')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};

// 客户服务情况报表
exports.getServcWorkVoucherByBuyer = function (data, callback) {
    api.post('/statis/work/servc/work/voucher/by/buyer')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};

// 客户服务情况报表  -- 导出
exports.doStatisBuyerComWorkVoucherInfoForExport = function (data, callback) {
    api.post('/statis/work/buyerCom/workload/statis/list/export/do')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};

exports.getServicerShopWorkVoucherStatisList = function (data, callback) {// 服务商网点工单报表
    api.post('/statis/work/servicerShop/work/voucher/statis/list/get')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};
// 导出服务网点工单报表，缓存过滤条件
exports.doServcShopWorkVoucherStatisListForExport = function (data, callback) {
    api.post('/statis/work/servicerShop/work/voucher/statis/list/export/do')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};

// 统计-工程师工作量
exports.getServicerEngineerWorkloadStatisList = function (data, callback) {
    api.post('/statis/work/engineer/workload/list/get')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};

// 统计-单个工程师工作量
exports.getServicerEngineerWorkloadStatis = function (data, callback) {
    api.post('/statis/work/engineer/workload/get')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};

// 统计-工程师工作量-导出url
exports.getServicerEngineerWorkloadStatisListExportUrl = function (data, callback) {
    api.post('/statis/work/engineer/workload/list/export/url/get')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};

// 工程师维修记录
exports.getServcEngineerRepairRecList = function (data, callback) {
    api.post('/statis/work/engineer/repair/rec/list/get')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};

// 工程师维修记录-保存导出参数返回uuid
exports.saveServcStaffWorkRecDocParamsForExport = function (data, callback) {
    api.post('/statis/work/engineer/repair/rec/list/params/for/export/url')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};

// 工程师绩效统计
exports.getEngineerEvalStatisList = function (data, callback) {
    api.post('/statis/work/engineer/list/get/for/performance/statis')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};

// 故障类型统计
exports.getFaultTypeStatisList = function (data, callback) {
    api.post('/statis/work/faultType/statis/list/get')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};

// 故障类型统计-导出url
exports.doFaultTypeStatisListForExport = function (data, callback) {
    api.post('/statis/work/faultType/statis/list/export/do')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};

// 配件使用统计
exports.getServicerShopAccStatisList = function (data, callback) {
    api.post('/statis/work/srevicer/shop/acc/statis/list')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};
// 配件使用统计 - 导出
exports.doStatisServicerShopAccForExport = function (data, callback) {
    api.post('/statis/work/srevicer/shop/acc/for/export')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};

export default exports;



//////////////////
// WEBPACK FOOTER
// ./src/api/statisWork.js
// module id = 77
// module chunks = 1